import "./FooterStyles.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="top">
        <div>
          <h1 className="footer-title">AURORA</h1>
          <p className="info">crew@aurora-crewing.com</p>
          <p className="info">+351 965 118 884</p>
          <p className="info">Portugal, Portimāo</p>
          <p className="info">+38 093 072 61 57 </p>
          <p className="info">+38 063 464 28 10 </p>
          <p className="info">Ukraine, Odesa</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
